import { render, staticRenderFns } from "./UsuarioRead.vue?vue&type=template&id=01f745c0&"
import script from "./UsuarioRead.vue?vue&type=script&lang=js&"
export * from "./UsuarioRead.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioRead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports